import React from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmIndustryPrompt } from 'components/ConfirmIndustryPrompt'
import { useVerticalContext } from 'hooks/context/useVerticalContext'
import { VerificationHeader } from '../_components/VerificationHeader'
import { BusinessComplianceForm } from './components/BusinessComplianceForm'

export const BusinessCompliance = () => {
  const { t } = useTranslation()
  const { isIndustryConfirmed } = useVerticalContext()

  return (
    <>
      <VerificationHeader header={t('verification.routes.businessCompliance')} />
      {isIndustryConfirmed ? <BusinessComplianceForm /> : <ConfirmIndustryPrompt />}
    </>
  )
}
